import { RouteHelpers } from 'helpers/routerHelpers';
import { Attributes, Variant } from 'shared/types/product';
import { ProductCardProduct } from 'shared/types/product/Product';

const TYPES = {
  BULBS: 'bulbs',
  RUGSANDRUGACCESSORIES: 'rugsAndRugAccessories',
};

export function findCommonFilterRugSize(products: ProductCardProduct[]): string | undefined {
  const filterRugSizeKeys: Array<Set<string>> = products.map(
    (product) =>
      new Set(
        product.variants.flatMap((variant) =>
          variant?.attributes?.filterRugSize.map((filterRugSize: Attributes) => filterRugSize.key),
        ),
      ),
  );

  const commonKey = Array.from(filterRugSizeKeys.reduce((a, b) => new Set([...a].filter((x) => b.has(x))))).shift();

  return commonKey;
}

export function filterVariantsInSupplies(supplies: ProductCardProduct[], size: string) {
  const filteredSupplies = supplies
    .map((supply) => {
      const matchingVariant = supply.variants.find((variant) => {
        return variant?.attributes?.size === size;
      });

      if (matchingVariant) {
        return {
          ...supply,
          variants: [matchingVariant],
        };
      }
      return null;
    })
    .filter((supply) => supply !== null);

  return filteredSupplies?.slice(0, 6);
}

export function getMoreCompatible(variant: Variant, supplies: ProductCardProduct[]) {
  const supplyProductType = supplies?.[0]?.productType?.key;

  if (supplyProductType === TYPES.BULBS) {
    const bulbBase = variant?.attributes?.bulbBase.key;

    return {
      label: 'See More Compatible Bulbs',
      slug: `/categories/all-light-bulbs${RouteHelpers.encodeToURL({ bulbBase })}`,
    };
  }

  if (supplyProductType === TYPES.RUGSANDRUGACCESSORIES) {
    const commonRugSize = findCommonFilterRugSize(supplies);
    return {
      label: 'See More Rug Pads & Sizes',
      slug: `/categories/rug-pads${RouteHelpers.encodeToURL({ filterRugSize: commonRugSize })}`,
    };
  }
  return { label: '', slug: '#' };
}

export function getTitle(supplies: ProductCardProduct[]) {
  const supplyProductType = supplies?.[0]?.productType?.key;

  if (supplyProductType === TYPES.BULBS)
    return "We've found some bulbs that would look great with your new light fixture:";

  if (supplyProductType === TYPES.RUGSANDRUGACCESSORIES)
    return 'Add a non-slip pad for your new rug to prevent premature wear:';

  return '';
}
